import styled from 'styled-components'

export const Container = styled.div`
  .ant-drawer-body {
    padding: 0;
  }
`
export const Tools = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  width: 20rem;
  height: 90vh;
  right: 0;
  margin: 1rem;
`
export const Content = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;

  .Content__map {
    width: calc(100% - 300px);
    height: 100%;
    background: blue;
    border-radius: 16px;
    overflow: hidden;
    position: relative;

    .Content__map__options {
      width: 310px;
      /* height: 100px; */
      border-radius: 8px;
      background: #fff;
      position: absolute;
      top: 12px;
      left: 12px;
      z-index: 2;
      box-sizing: border-box;
      padding: 12px;

      .Content__map__options__inputs {
        margin-top: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;
      }
    }
  }

  .Content_form {
    width: 300px;
    flex-direction: column;
  }
`;